import lodashUtil from 'lodash';
import * as StringReplacer from '../../../i18n/StringReplacer'
import { getKeyFromLS } from '../../../utils/LocalStorageUtil'
export const constructGradeLevelJSONToBeRendered = (gradeLevels) => {
  for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
    gradeLevels.gradeLevels[i].isGradeLevelSelected = true;
    gradeLevels.gradeLevels[i].isGradeLevelIntermediate = false;
    for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
      gradeLevels.gradeLevels[i].grades[j].isGradeSelected = true;
      gradeLevels.gradeLevels[i].grades[j].isGradeLevelIntermediate = false;
      for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
        gradeLevels.gradeLevels[i].grades[j].groups[k].isGroupSelected = true;
        gradeLevels.gradeLevels[i].grades[j].groups[k].isGradeLevelIntermediate = false;
      }
    }
  }
  gradeLevels.isAllChecked = true;
  gradeLevels.indeterminate = false
  return gradeLevels;
}

export const constructGradeLevelJSONToBeRenderedAllFalse = (gradeLevels) => {
  for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
    gradeLevels.gradeLevels[i].isGradeLevelSelected = false;
    for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
      gradeLevels.gradeLevels[i].grades[j].isGradeSelected = false;
      for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
        gradeLevels.gradeLevels[i].grades[j].groups[k].isGroupSelected = false;
      }
    }
  }
  return gradeLevels;
}

export const constructGradeLevelJSON = (gradeLevels, gradeDetails) => {
  let constructdGradeLevels = {}
  if (gradeDetails !== undefined && gradeDetails.allGrades == true) {
    gradeLevels = constructGradeLevelJSONToBeRendered(gradeLevels)
    gradeLevels.isAllChecked = true;
    gradeLevels.indeterminate = false;
  }
  else {
    gradeLevels = constructGradeLevelJSONToBeRenderedAllFalse(gradeLevels)
    if (gradeLevels.gradeLevels.length > gradeDetails.gradeLevels.length && (gradeDetails.gradeLevels.length != 0 || gradeDetails.grades.length != 0)) {
      gradeLevels.indeterminate = true;
    }
    gradeLevels.isAllChecked = false;

    if (gradeDetails.gradeLevels !== undefined) {
      for (let x = 0; x < gradeDetails.gradeLevels.length; x++) {
        for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
          if (gradeDetails.gradeLevels[x].level == gradeLevels.gradeLevels[i].levelName) {
            gradeLevels.gradeLevels[i].isGradeLevelSelected = true;
            for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
              gradeLevels.gradeLevels[i].grades[j].isGradeSelected = true;
              gradeLevels.gradeLevels[i].grades[j].isGradeLevelIntermediate = true;
              for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
                gradeLevels.gradeLevels[i].grades[j].groups[k].isGroupSelected = true;
              }
            }
          }
        }
      }
      if (gradeDetails.grades !== undefined) {
        for (let xIndex = 0; xIndex < gradeDetails.grades.length; xIndex++) {
          for (let iIndex = 0; iIndex < gradeLevels.gradeLevels.length; iIndex++) {
            if (gradeLevels.gradeLevels[iIndex].isGradeLevelSelected == false) {
              for (let jIndex = 0; jIndex < gradeLevels.gradeLevels[iIndex].grades.length; jIndex++) {
                if (gradeDetails.grades[xIndex].grade == gradeLevels.gradeLevels[iIndex].grades[jIndex].gradeName) {
                  gradeLevels.gradeLevels[iIndex].isGradeLevelIntermediate = true;
                  gradeLevels.gradeLevels.indeterminate = true;
                  if (gradeDetails.grades[xIndex].groups == undefined || gradeDetails.grades[xIndex].groups.length == 0) {
                    gradeLevels.gradeLevels[iIndex].grades[jIndex].isGradeSelected = true;
                    for (let kIndex = 0; kIndex < gradeLevels.gradeLevels[iIndex].grades[jIndex].groups.length; kIndex++) {
                      gradeLevels.gradeLevels[iIndex].grades[jIndex].groups[kIndex].isGroupSelected = true;
                    }
                  }
                  else {
                    if (gradeDetails.grades[xIndex].groups.length > 0) {
                      for (let yIndex = 0; yIndex < gradeDetails.grades[xIndex].groups.length; yIndex++) {
                        for (let k = 0; k < gradeLevels.gradeLevels[iIndex].grades[jIndex].groups.length; k++) {
                          if (gradeDetails.grades[xIndex].groups[yIndex].groupCode == gradeLevels.gradeLevels[iIndex].grades[jIndex].groups[k].groupName) {
                            gradeLevels.gradeLevels[iIndex].grades[jIndex].groups[k].isGroupSelected = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return gradeLevels;
}

export const getGradesString = (gradeDetails) => {
  let i18n = getKeyFromLS("i18n");
  let gradesString = [];
  // if the SUBJECT is not selected for even one grade.
  if (gradeDetails.grades.length === 0
    && gradeDetails.gradeLevels.length === 0
    && gradeDetails.allGrades === false) {
    gradesString.push(i18n.gradeDisplayString.noGradeIsSelected);
  }
  //if the subject is seleted for atleast one grade.
  else {
    if (gradeDetails !== undefined && gradeDetails !== null && gradeDetails.allGrades == true) {
      if (gradesString.length === 0) {
        gradesString.push("All Grades");
      }
    } else {
      if (gradeDetails.gradeLevels !== undefined && gradeDetails.gradeLevels.length > 0) {
        for (let x = 0; x < gradeDetails.gradeLevels.length; x++) {
          if (gradesString.length === 0) {
            gradesString.push(gradeDetails.gradeLevels[x].level);
          } else {
            gradesString.push(", " + gradeDetails.gradeLevels[x].level);
          }

        }
      }
      if (gradeDetails.grades !== undefined && gradeDetails.grades.length > 0) {
        for (let x = 0; x < gradeDetails.grades.length; x++) {
          if (gradesString.length === 0) {
            gradesString.push(gradeDetails.grades[x].grade);
          } else {
            gradesString.push(", " + gradeDetails.grades[x].grade);
          }
        }
      }
    }
  }
  return gradesString;
}

export const getGradesDetailedString = (gradeDetails, gradeLevels) => {
  let gradesString = [];

  if (gradeDetails !== undefined && gradeDetails.allGrades == true) {
    for (let i = 0; i < gradeLevels.length; i++) {
      gradesString.push(gradeLevels[i].levelName);
      for (let j = 0; j < gradeLevels[i].grades.length; j++) {
        gradesString.push(gradeLevels[i].grades[j].gradeName);
      }
    }
  } else {
    if (gradeDetails.gradeLevels !== undefined) {
      for (let x = 0; x < gradeDetails.gradeLevels.length; x++) {
        for (let i = 0; i < gradeLevels.length; i++) {
          if (gradeDetails.gradeLevels[x].level == gradeLevels[i].levelName) {
            gradesString.push(gradeLevels[i].levelName);
            for (let j = 0; j < gradeLevels[i].grades.length; j++) {
              gradesString.push(gradeLevels[i].grades[j].gradeName);
            }
          }
        }
      }
    }
    if (gradeDetails.grades !== undefined) {
      for (let x = 0; x < gradeDetails.grades.length; x++) {
        for (let i = 0; i < gradeLevels.length; i++) {
          for (let j = 0; j < gradeLevels[i].grades.length; j++) {
            if (gradeDetails.grades[x].grade == gradeLevels[i].grades[j].gradeName) {
              gradesString.push(gradeLevels[i].grades[j].gradeName);
            }
          }
        }
      }
    }
  }
  return gradesString;
}

export const showSubsetOfGrades = (gradeLevelsToBeRendered, gradeDetails) => {
  let copyOfGradeLevels = JSON.parse(JSON.stringify(gradeLevelsToBeRendered));
  let gradeLevelsToBeShown = [];
  //if selected ALL GRADES = TRUE
  if (gradeDetails.allGrades === true) {
    gradeLevelsToBeShown = copyOfGradeLevels.gradeLevels;
  }
  // ALL GRADES = FALSE 
  else {
    // GRADE LEVELS LENGTH > 0
    if (gradeDetails.gradeLevels.length > 0) {
      for (let i = 0; i < gradeDetails.gradeLevels.length; i++) {
        let level = JSON.parse(JSON.stringify(gradeDetails.gradeLevels[i].level));
        let levelPresent = lodashUtil.find(copyOfGradeLevels.gradeLevels, ["levelName", level]);
        if (levelPresent !== undefined) {
          gradeLevelsToBeShown.push(levelPresent);
        }
      }
    }
    //GROUPS 
    if (gradeDetails.grades.length > 0) {
      for (let j = 0; j < gradeDetails.grades.length; j++) {
        let grade = gradeDetails.grades[j].grade;
        for (let k = 0; k < copyOfGradeLevels.gradeLevels.length; k++) {
          // master data LEVEL OBJECT
          let levelObj = JSON.parse(JSON.stringify(copyOfGradeLevels.gradeLevels[k]))
          let gradeObj = lodashUtil.find(levelObj.grades, ["gradeName", grade]);
          if (gradeObj !== undefined) {
            let isLevelAlreadyPresent = lodashUtil.findIndex(gradeLevelsToBeShown, ["levelName", levelObj.levelName]);
            // if the LEVEL is already there then do not push it again
            if (isLevelAlreadyPresent !== -1) {
              gradeLevelsToBeShown[isLevelAlreadyPresent].grades.push(gradeObj);
              break;
            }
            //LEVEL is not present
            // create the level and then empty the grades and push that particular selected grade.
            else {
              levelObj.grades = [];
              levelObj.grades.push(gradeObj);
              gradeLevelsToBeShown.push(levelObj);
              break;
            }
          }
        }
      }
    }
  }
  copyOfGradeLevels.gradeLevels = gradeLevelsToBeShown;
  copyOfGradeLevels.isAllChecked = false;
  // copyOfGradeLevels.isIntermediate = true;
  copyOfGradeLevels.isSubset = true;
  copyOfGradeLevels = sortingOfGradeLevels(gradeLevelsToBeRendered, copyOfGradeLevels);
  return copyOfGradeLevels;
}

const sortingOfGradeLevels = (masterGradeLevel, copyOfGradeLevels) => {
  let gradeLevelObj = JSON.parse(JSON.stringify(copyOfGradeLevels));
  let sortedGradeLevels = []
  for (let a = 0; a < masterGradeLevel.gradeLevels.length; a++) {
    let levelName = masterGradeLevel.gradeLevels[a].levelName;
    let levelObj = lodashUtil.find(copyOfGradeLevels.gradeLevels, ["levelName", levelName]);
    if (levelObj !== undefined) {
      sortedGradeLevels.push(JSON.parse(JSON.stringify(levelObj)));
    }
  }
  gradeLevelObj.gradeLevels = sortedGradeLevels
  return gradeLevelObj;
}


export const constructGradeDetailsFromSubset = (subsetGradeDetails, assignedSubjectGradeDetails) => {


}

export const isGradeIncluded = (glevel, grade, group, gradeDetails) => {
  if (gradeDetails && gradeDetails.allGrades == true) {
    return true;

  }
  else {
    if (gradeDetails.gradeLevels && !gradeDetails.grades) {
      for (let x = 0; x < gradeDetails.gradeLevels.length; x++) {
        if (glevel === gradeDetails.gradeLevels[x].level) {
          return true;
        }

      }
      return false;
    } else if (gradeDetails.grades) {
      for (let x = 0; x < gradeDetails.grades.length; x++) {
        let agrade = gradeDetails.grades[x];
        if (agrade === grade) {
          if (agrade.groups) {
            for (let y = 0; y < gradeDetails.groups.length; y++) {
              let agroup = gradeDetails.groups[y];
              if (agroup === group) {
                return true;
              } else {
                return false;
              }
            }

          } else {
            return true;
          }
        }
      }

    } else {
      return false;
    }

  }
}

/*
		this method takes in gradeDetails as parameter and it converts one object into an array with just string in the lowest form
	*/
export const convertingGradeDetailsToLowestFormat = (gradeDetails, props) => {
  let gradeStringArray = [];
  let master_gradeLevels = props.activeSchool.school_master.gradeLevels;
  if (gradeDetails.allGrades === false) {
    let gradeLevels = gradeDetails.gradeLevels;
    let grades = gradeDetails.grades;

    /**
     * === GRADE lEVELS ===
     */
    if (gradeLevels.length > 0) {
      //GRADEDETAILS LEVEL ARRAY
      for (let i = 0; i < gradeLevels.length; i++) {
        let level = gradeLevels[i].level
        let levelObj = lodashUtil.find(master_gradeLevels, ["levelName", level])
        if (levelObj !== undefined) {

          // MASTER_GRADE LEVEL ARRAY
          for (let j = 0; j < levelObj.grades.length; j++) {
            let gradeArray = levelObj.grades[j];

            // MASTER_GRADE ARRAY
            for (let k = 0; k < gradeArray.groups.length; k++) {
              let gradeName = gradeArray.gradeName
              let groupName = gradeArray.groups[k].groupName
              let gradeString = gradeName + groupName
              gradeStringArray.push(gradeString)
            }

          }
        }
      }
    }

    /**
     * === GRADES ===
     */
    if (grades.length > 0) {
      for (let a = 0; a < grades.length; a++) {
        let gradeObj = grades[a]

        // if the gradeDetail has only GRADE
        if (gradeObj.groups === undefined || gradeObj.groups.length === 0) {

          // get the GRADE NAME and then find the grade in the master by looping over the grade levels.
          for (let x = 0; x < master_gradeLevels.length; x++) {
            let master_gradeLevelObj = master_gradeLevels[x]
            let gradeObject = lodashUtil.find(master_gradeLevelObj.grades, ["gradeName", gradeObj.grade]);
            if (gradeObject !== undefined) {
              //MASTER_GROUPS
              let gradeName = gradeObject.gradeName;
              let groupsArray = gradeObject.groups;

              for (let y = 0; y < groupsArray.length; y++) {
                let groupName = groupsArray[y].groupName
                let gradeString = gradeName + groupName;
                gradeStringArray.push(gradeString);
              }
            }
          }
        }
        /**
         * if the gradeDetails also has GROUPS
         */
        else {
          let gradeName = gradeObj.grade
          for (let z = 0; z < gradeObj.groups.length; z++) {
            let groupObj = gradeObj.groups[z];
            let groupName = groupObj.groupCode;
            let gradeString = gradeName + groupName;
            gradeStringArray.push(gradeString);
          }
        }
      }
    }
  }
  // ALL GRADE = TRUE
  else {
    for (let p = 0; p < master_gradeLevels.length; p++) {
      let gradeLevelObj = master_gradeLevels[p];
      for (let q = 0; q < gradeLevelObj.grades.length; q++) {
        let gradeObj = gradeLevelObj.grades[q];
        let gradeName = gradeObj.gradeName
        for (let r = 0; r < gradeObj.groups.length; r++) {
          let groupObj = gradeObj.groups[r];
          let groupName = groupObj.groupName;
          let gradeString = gradeName + groupName;
          gradeStringArray.push(gradeString)
        }
      }
    }
  }
  return gradeStringArray;
}

export const gradeLevelObjectToBeChangedToTrue = (gradeLevelObj) => {
  let gradeLevelObject = gradeLevelObj
  if (gradeLevelObject.isGradeLevelIntermediate === true) {
    for (let x = 0; x < gradeLevelObject.grades.length; x++) {
      let gradeObj = gradeLevelObject.grades[x];
      gradeObj.isGradeSelected = true;
      gradeObj.isGradeLevelIntermediate = false;
      for (let y = 0; y < gradeObj.groups.length; y++) {
        let groupObj = gradeObj.groups[y];
        groupObj.isGroupSelected = true;
        groupObj.isGradeLevelIntermediate = false;
      }
    }
  } else {
    for (let a = 0; a < gradeLevelObject.grades.length; a++) {
      let gradeObj = gradeLevelObject.grades[a];
      gradeObj.isGradeSelected = false;
      gradeObj.isGradeLevelIntermediate = false;
      for (let b = 0; b < gradeObj.groups.length; b++) {
        let groupObj = gradeObj.groups[b];
        groupObj.isGroupSelected = false;
        groupObj.isGradeLevelIntermediate = false;
      }
    }
  }
  return gradeLevelObject;
}

/**
	 * method takes in a "GRADE DETAIL and PROPS"  where allGrades flag is true and 
	 * then it converts it to the gradeLevels with all the grageLevel present in the school master.
   * 
	 * Returns back a new gradeDetaila object
	 */
export const changingSubsetGradeDetail = (gradeDetails, props) => {
  let gradeDetailObj = {};
  let gradeLevels = [];
  if (gradeDetails.allGrades === true) {
    let master_gradeLevels = props.activeSchool.school_master.gradeLevels
    for (let a = 0; a < master_gradeLevels.length; a++) {
      let gradeLevelObj = master_gradeLevels[a]
      gradeLevels.push({ level: gradeLevelObj.levelName })
    }
    gradeDetailObj.allGrades = false;
    gradeDetailObj.gradeLevels = gradeLevels;
    gradeDetailObj.grades = [];

  } else {
    gradeDetailObj = gradeDetails
  }
  return gradeDetailObj;
}

/**
 * this method takes in 
 * 1. grade detail 
 * 2. props(to get the master grades) 
 */
export const displayingGradeDetailString = (gradeDetail, props) => {
  let finalString = "";
  let tempStringArray = [];
  let isGroupsPresent = false;
  let master_gradeLevels = props.activeSchool.school_master.gradeLevels;
  let gradeNumber = [];
  const i18n = props.i18n
  // ALLGRADES = TRUE
  if (gradeDetail.allGrades === true) {
    finalString = i18n.gradeDisplayString.allGradesAllSections;
  }
  //ALLGRADES != TRUE 
  else {

    for (let x = 0; x < master_gradeLevels.length; x++) {
      let master_gradeLevelObj = master_gradeLevels[x]
      //GRADE NUMBER ARRAY 
      for (let y = 0; y < master_gradeLevelObj.grades.length; y++) {
        gradeNumber.push(master_gradeLevelObj.grades[y].gradeName)
      }

      let isGradeLevelPresent = lodashUtil.find(gradeDetail.gradeLevels, ["level", master_gradeLevelObj.levelName])
      //GRADE LEVEL
      if (isGradeLevelPresent != undefined) {
        for (let i = 0; i < master_gradeLevelObj.grades.length; i++) {
          let gradeObj = master_gradeLevelObj.grades[i]
          tempStringArray.push(gradeObj.gradeName);
        }
      }
      // GRADE => gradeLevel is not present hence check for the individual GRADE if present
      else {
        if (gradeDetail.grades.length != 0) {
          for (let j = 0; j < gradeDetail.grades.length; j++) {
            let gradeObject = gradeDetail.grades[j];
            let isGradePresent = lodashUtil.find(master_gradeLevelObj.grades, ["gradeName", gradeObject.grade]);
            //GRADE is present
            if (isGradePresent != undefined) {
              // GRADE ONLY
              if (gradeObject.groups === undefined || gradeObject.groups.length === 0) {
                tempStringArray.push(gradeObject.grade)
              }
              // GROUPS 
              else {
                isGroupsPresent = true;
                for (let b = 0; b < gradeObject.groups.length; b++) {
                  let groupsObj = gradeObject.groups[b]
                  tempStringArray.push(`${gradeObject.grade}${groupsObj.groupCode}`)
                }
              }
            }
          }
        }
      }
    }
  }

  if (isGroupsPresent === false) {
    // length 3 => then show all the grades ex => 10,11,12
    if (tempStringArray.length <= 3) {
      finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.gradesWithAllSections,
        {
          grades: tempStringArray.toString()
        })
    }
    // MORE THAN 3 => if there are more number of grades in sequence then show ex => 8-12 
    else {
      let isGradeInSequence = true;
      let gradeNumIndex = gradeNumber.indexOf(tempStringArray[0]);
      let increment = 0
      for (let c = 0; c < tempStringArray.length; c++) {

        if (tempStringArray[c] != gradeNumber[gradeNumIndex + increment]) {
          isGradeInSequence = false
          break
        } else {
          increment++
        }
      }

      if (isGradeInSequence === true) {

        finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.fromAndToGradesWithAllSections,
          {
            fromGrade: tempStringArray[0],
            toGrade: tempStringArray[tempStringArray.length - 1]
          })

      } else {
        finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.gradesWithAllSections,
          {
            grades: tempStringArray.toString()
          })
      }
    }
  }
  // groups is present just convert tempString to final String
  else {
    finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.gradesWithoutAllSections,
      {
        grades: tempStringArray.toString()
      })
  }
  return finalString
}

export const displayingGradeDetailString_Rules = (gradeDetail, props) => {
  let finalString = "";
  let tempStringArray = [];
  let isGroupsPresent = false;
  let master_gradeLevels = props.activeSchool.school_master.gradeLevels;
  let gradeNumber = [];
  const i18n = props.i18n

  for (let x = 0; x < master_gradeLevels.length; x++) {
    let master_gradeLevelObj = master_gradeLevels[x];
    for (let y = 0; y < master_gradeLevelObj.grades.length; y++) {
      gradeNumber.push(master_gradeLevelObj.grades[y].gradeName)
    }
  }

  for (let i = 0; i < gradeDetail.grades.length; i++) {
    let gradeObj = gradeDetail.grades[i]

    for (let j = 0; j < master_gradeLevels.length; j++) {
      let master_gradeLevelObj = master_gradeLevels[j]
      let isGradePresent = lodashUtil.find(master_gradeLevelObj.grades, ["gradeName", gradeObj.grade])
      if (isGradePresent != undefined) {
        if (isGradePresent.numberOfGroups === gradeObj.groups.length) {
          tempStringArray.push(gradeObj.grade)
        } else {
          for (let k = 0; k < gradeObj.groups.length; k++) {
            let groupsObj = gradeObj.groups[k]
            tempStringArray.push(`${gradeObj.grade}${groupsObj.groupCode}`)
          }
          isGroupsPresent = true
        }
      }
    }

  }

  if (isGroupsPresent === false) {
    // length 3 => then show all the grades ex => 10,11,12
    if (tempStringArray.length <= 3) {
      finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.gradesWithAllSections,
        {
          grades: tempStringArray.toString()
        })
    }
    // MORE THAN 3 => if there are more number of grades in sequence then show ex => 8-12 
    else {
      let isGradeInSequence = true;
      let gradeNumIndex = gradeNumber.indexOf(tempStringArray[0]);
      let increment = 0
      for (let c = 0; c < tempStringArray.length; c++) {

        if (tempStringArray[c] != gradeNumber[gradeNumIndex + increment]) {
          isGradeInSequence = false
          break
        } else {
          increment++
        }
      }

      if (isGradeInSequence === true) {

        finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.fromAndToGradesWithAllSections,
          {
            fromGrade: tempStringArray[0],
            toGrade: tempStringArray[tempStringArray.length - 1]
          })

      } else {
        finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.gradesWithAllSections,
          {
            grades: tempStringArray.toString()
          })
      }
    }
  }
  // groups is present just convert tempString to final String
  else {
    finalString = StringReplacer.getFormatedMessage(i18n.gradeDisplayString.gradesWithoutAllSections,
      {
        grades: tempStringArray.toString()
      })
  }
  return finalString
}

export const sortingOfGrades = (gradeDetails, props) => {
  let gradeNumber = [];
  let tempGradesArray = [];
  let master_gradeLevels = props.activeSchool.school_master.gradeLevels;
  for (let x = 0; x < master_gradeLevels.length; x++) {
    let master_gradeLevelObj = master_gradeLevels[x];
    for (let y = 0; y < master_gradeLevelObj.grades.length; y++) {
      gradeNumber.push(master_gradeLevelObj.grades[y].gradeName)
    }
  }

  for (let g = 0; g < gradeNumber.length; g++) {
    let gradeNum = gradeNumber[g];
    let gradeObj = lodashUtil.find(gradeDetails.grades, ["grade", gradeNum]);
    if (gradeObj != undefined) {
      tempGradesArray.push(JSON.parse(JSON.stringify(gradeObj)));
    }
  }
  gradeDetails.grades = JSON.parse(JSON.stringify(tempGradesArray))
  return gradeDetails
}

export const getGradeLevelByGrade = (gradeLevels, gradeName) => {
  for (let x = 0; x < gradeLevels.length; x++) {
    let master_gradeLevelObj = gradeLevels[x];
    for (let y = 0; y < master_gradeLevelObj.grades.length; y++) {
      if(gradeName === master_gradeLevelObj.grades[y].gradeName){
        return master_gradeLevelObj.levelName
      }
    }
  }
}